export default function (state = {clr: 5,dsc:5, selected_filter: "",oar_low: 0,oar_high:10,age_low:0,age_high: 65,pref_age:59,income: 0, education: 0,pref_fans: 0}, action) {
    switch (action.type) {
        case 'Save_Current_Adhoc_Search':
            return {
              clr: action.data.clr,
              dsc: action.data.dsc,
              selected_filter: action.data.selected_filter,
              oar_low: action.data.oar_low,
              oar_high: action.data.oar_high,
              age_low: action.data.age_low,
              age_high: action.data.age_high,
              pref_age: action.data.pref_age,
              income: action.data.income,
              education: action.data.education,
              pref_fans: action.data.pref_fans,
            };
            break;


    }
    return state;
}



// WEBPACK FOOTER //
// ./src/config/allReducers/adhoc/filters.js